import type GetAllPositionsDTO from '../repositories/position/dto/getAll.dto'
import type GetAllTradesDTO from '../repositories/tradeHistory/dto/getAllTradeHistory.dto'
import type PositionsController from '../controllers/positions/positions.controller'
import type TradeHistoryController from '../controllers/tradeHistory/tradeHistory.controller'
import type TradeHistoryModel from '../models/tradeHistory.model'
import type PositionModel from '../models/position.model'
import { type ChanelActionType, PositionApiWS, type PositionWSUpdate } from "@trading/infrastructure";

export default class Positions {
  constructor(
    private history: TradeHistoryController,
    private positions: PositionsController,
    private repoWS: PositionApiWS
  ) {
  }

  async getAllTrades(dto: GetAllTradesDTO): Promise<TradeHistoryModel> {
    return await this.history.getAllTradeHistory(dto)
  }

  async getAllPositions(dto: GetAllPositionsDTO): Promise<PositionModel[]> {
    return await this.positions.getAllPositions(dto)
  }

  async closePosition(id: ID) {
    return await this.positions.closePosition(id)
  }

  async doublePosition(position: PositionModel) {
    await this.positions.doublePosition(position)
  }

  async reversePosition(position: PositionModel) {
    await this.positions.reversePosition(position)
  }

  async modifyPosition(position: PositionModel) {
    await this.positions.modifyPosition(position)
  }

  async subscribeToPositionsChannel(
    actionName: ChanelActionType,
    cb: (order: PositionWSUpdate) => void
  ): Promise<undefined | CallableFunction> {
    return this.repoWS.subscribeToChannelsAction(actionName, cb)
  }

  unsubscribe(): void {
    this.repoWS.unsubscribeToChannel()
  }
}
